import Vue from 'vue'
import Router from 'vue-router'

import store from '@/store/'

import Login from '@/views/Login'
import Home from '@/views/Home'
import OrdemServico from '@/views/OrdemServico'
import ItensExecucao from '@/views/ItensExecucao'
import NovaOs from '@/views/NovaOs'
import osExterna from '@/views/osExterna'
import OsPreventiva from '@/views/OsPreventiva'
import OsPreditiva from '@/views/OsPreditiva'
import OsExternaArmazem from '@/views/OsExternaArmazem'
import OsReabertas from '@/views/OsReabertas'
import Historico from '@/views/Historico'
import Manutencao from '@/views/Manutencao'
import OsEmpilhadeira from '@/views/OsEmpilhadeira'
import OsPreventivaArmazem from '@/views/OsPreventivaArmazem'
import OsPaleteira from '@/views/OsPaleteira' 
import Inventario from '@/views/Inventario' 
import InventarioItens from '@/views/InventarioItens' 
import TabelaFrota from '@/views/Painel/TabelaFrota2' 
import MultiSql from '@/views/Painel/MultiSql' 
import LoginPainel from '@/views/Painel/LoginPainel' 
import InicioPainel from '@/views/Painel/InicioPainel' 
import AgendadorTarefas from '@/views/Painel/AgendadorTarefas' 
import Dicionario from '@/views/Painel/Dicionario' 
import Conjuntos from '@/views/Conjuntos'
import Monitoramento from '@/views/Painel/Monitoramento'
import Afericao from '@/views/Borracharia/Afericao'
import IndexBorracharia from '@/views/Borracharia/Index'
import Movimentacao from '@/views/Borracharia/Movimentacao'
import Descarte from '@/views/Borracharia/Descarte'
import Servico from '@/views/Borracharia/Servico'
import OsPreditivaArmazem from '@/views/OsPreditivaArmazem'
import DesbloqueiaEmpilhadeira from '@/views/DesbloqueiaEmpilhadeira'
import Dashboard from '@/views/Dashboard'
import Guard from './middleware'


Vue.use(Router)

const appTitle = 'Terminal da Oficina'

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { title: `${appTitle} - Login` }
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: { title: `${appTitle} - Home` }
    },
    {
      path: '/os/:id',
      name: 'OrdemServico',
      component: OrdemServico,
      meta: { title: `${appTitle} - OS` }
    },    
    {
      path: '/os/:id/:osExterna',
      name: 'OrdemServicoExterna',
      component: OrdemServico,
      meta: { title: `${appTitle} - OS` }
    },
    {
      path: '/execucao',
      name: 'ItensExecucao',
      component: ItensExecucao,
      meta: { title: `${appTitle} - Execução` }
    },
    {
      path: '/novaOs',
      name: 'novaOs',
      component: NovaOs,
      meta: { title: `${appTitle} - Nova OS` }
    },
    {
      path: '/osExterna',
      name: 'osExterna',
      component: osExterna,
      meta: { title: `${appTitle} - OS Externa` }
    },
    {
      path: '/osPreventiva',
      name: 'osPreventiva',
      component: OsPreventiva,
      meta: { title: `${appTitle} - OS Preventiva` }
    },
    {
      path: '/osPreditiva',
      name: 'osPreditiva',
      component: OsPreditiva,
      meta: { title: `${appTitle} - OS Preditiva` }
    },
    {
      path: '/osReabertas',
      name: 'osReabertas',
      component: OsReabertas,
      meta: { title: `${appTitle} - OS Reabertas` }
    },
    {
      path: '/historico',
      name: 'historico',
      component: Historico,
      meta: { title: `${appTitle} - Histórico` }
    },
    {
      path: '/manutencao',
      name: 'manutencao',
      component: Manutencao,
      meta: { title: `${appTitle} - Manutenção` }
    },
    {
      path: '/osEmpilhadeira',
      name: 'osEmpilhadeira',
      component: OsEmpilhadeira,
      meta: { title: `${appTitle} - Empilhadeira` }
    },
    {
      path: '/osPreventivaArmazem',
      name: 'osPreventivaArmazem',
      component: OsPreventivaArmazem,
      meta: { title: `${appTitle} - Empilhadeira` }
    },
    {
      path: '/osExternaArmazem',
      name: 'osExternaArmazem',
      component: OsExternaArmazem,
      meta: { title: `${appTitle} - Empilhadeira` }
    },
    {
      path: '/osPaleteira',
      name: 'osPaleteira',
      component: OsPaleteira,
      meta: { title: `${appTitle} - Paleteira` }
    },
    {
      path: '/inventario',
      name: 'inventario',
      component: Inventario,
      meta: { title: `${appTitle} - Inventário` }
    },
    {
      path: '/inventarioItens/:id',
      name: 'inventarioItens',
      component: InventarioItens,
      meta: { title: `${appTitle} - Itens` }
    },
    {
      path: '/conjuntos',
      name: 'conjuntos',
      component: Conjuntos,
      meta: { title: `${appTitle} - Conjuntos` }
    },
    {
      path: '/TabelaFrota',
      name: 'TabelaFrota',
      component: TabelaFrota,
      beforeEnter: Guard.auth
      // meta: { title: `${appTitle} - Itens` }
    },
    {
      path: '/MultiSql',
      name: 'MultiSql',
      component: MultiSql,
      beforeEnter: Guard.auth
      // meta: { title: `${appTitle} - Itens` }
    },
    {
      path: '/loginPainel',
      name: 'LoginPainel',
      component: LoginPainel,
      beforeEnter: Guard.auth
      // meta: { title: `${appTitle} - Itens` }
    },
    {
      path: '/inicioPainel',
      name: 'InicioPainel',
      component: InicioPainel,
      beforeEnter: Guard.auth
      // meta: { title: `${appTitle} - Itens` }
    },
    {
      path: '/agendadorTarefas',
      name: 'AgendadorTarefas',
      component: AgendadorTarefas,
      beforeEnter: Guard.auth
      // meta: { title: `${appTitle} - Itens` }
    },
    {
      path: '/dicionario',
      name: 'dicionario',
      component: Dicionario,
      beforeEnter: Guard.auth
      // meta: { title: `${appTitle} - Itens` }
    },
    {
      path: '/monitoramento',
      name: 'monitoramento',
      component: Monitoramento,
      beforeEnter: Guard.auth
      // meta: { title: `${appTitle} - Itens` }
    },
    {
      path: '/borracharia/afericao',
      name: 'afericao',
      component: Afericao,
      // meta: { title: `${appTitle} - Itens` }
    },
    {
      path: '/borracharia/',
      name: 'indexBorracharia',
      component: IndexBorracharia,
      // meta: { title: `${appTitle} - Itens` }
    },
    {
      path: '/borracharia/movimentacao',
      name: 'movimentacao',
      component: Movimentacao,
      // meta: { title: `${appTitle} - Itens` }
    },
    {
      path: '/borracharia/descarte',
      name: 'descarte',
      component: Descarte,
      // meta: { title: `${appTitle} - Itens` }
    },
    {
      path: '/borracharia/servico',
      name: 'servico',
      component: Servico,
      // meta: { title: `${appTitle} - Itens` }
    },
    {
      path: '/osPredivitaArmazem',
      name: 'osPredivitaArmazem',
      component: OsPreditivaArmazem,
      // meta: { title: `${appTitle} - Itens` }
    },
    {
      path: '/desbloqueiaEmpilhadeira',
      name: 'desbloqueiaEmpilhadeira',
      component: DesbloqueiaEmpilhadeira,
      // meta: { title: `${appTitle} - Itens` }
    },
    {
      path: '/Dashboard',
      name: 'Dashboard',
      component: Dashboard,
      // meta: { title: `${appTitle} - Itens` }
    },
  ]
})

router.beforeEach((to, from, next) => {
  store.dispatch('filial/loadFromLocalStorage')
  store.dispatch('empresa/loadFromLocalStorage')
  if (to.fullPath !== '/login' && !store.getters['filial/filial']) {
    next('/login')
  }
  setTags(to, from, next)
  next()
})

const setTags = (to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags)
  // const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags)

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el))

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next()

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta')

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key])
    })

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '')

    return tag
  })
  // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag))
}

export default router
